import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

// Componentes.
import { QWebPrinterComponent } from './qWebPrinter.component';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NavigationBarModule } from '@blocks/navigation-bar/navigation-bar.module';

// Servicios.
import { QWebPrinterService } from '@services/qwebprinter.service';
import { ApiServerService } from '@services/api-server.service';
import { QsignerService } from '@services/qsigner.service';
import { StorageServiceModule } from 'angular-webstorage-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// Pdf.
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Syncfusion.
import { SignatureModule } from '@syncfusion/ej2-angular-inputs';

@NgModule({
  declarations: [QWebPrinterComponent],
  imports: [FormsModule, CommonModule, TranslateModule, BrowserModule, PdfViewerModule, NavigationBarModule, SignatureModule],
  exports: [QWebPrinterComponent],
  providers: [BsLocaleService, TranslateService, QWebPrinterService, ApiServerService, QsignerService, StorageServiceModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QWebPrinterModule {}
